import { REAL_ESTATE } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(REAL_ESTATE)
